import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

export const useResourceFormResource = (): string => {
  const { resource } = useResourceFormContext();
  return resource;
};
